export default __webpack_public_path__ + "static/tver-962a5c637d25b53e9978aa86c42f7891.webp";